import axios from 'axios';
import { print } from 'graphql';
import gql from 'graphql-tag';

export default function (categoryId) {
  return {
    articlesList: [],
    page: 0,
    limit: 6,
    total: 0,

    init() {
      this.loadArticles();
    },

    loadMoreArticles() {
      this.page++;
      this.loadArticles();
    },

    loadArticles() {
      let format = document.documentElement.getAttribute('lang').substring(0, 2) == "fr" ? 'j F Y' : 'F jS, Y';

      axios({
        url: '/actions/graphql/api',
        method: 'post',
        data: {
          query: print(gql`{
          entries(section: "news", site: "${window.currentSite}", limit: ${this.limit}, offset: ${this.page * this.limit}, relatedTo: ${categoryId}, orderBy: "featuredArticle DESC, postDate DESC") {
            title
    				url
    				postDate @formatDateTime (format: "${format}")
            ...on news_default_Entry {
              newsCategory {
                title
              }
              image {
                url(format: "jpeg")
              }
              featuredArticle
            }
          }
          entryCount(section: "news", site: "${window.currentSite}", relatedTo: ${categoryId})
          }`)
        }
      }).then((result) => {
        this.articlesList = this.articlesList.concat(result.data.data.entries);
        this.total = result.data.data.entryCount;
      }).catch((error) => { });
    }
  };
}
